export class TblBidDataDisplay {
  id?: number;
  Domicile: string;
  Position: string;
  Round: number;
  Month: number;
  offline?: boolean;
  Year: number;
  fieldId?: string;
  size?: string;
  modified?: any;
  created?: any;
  EmpNum: any;
  showDelete?: boolean;
  bidPeriodStartDate?: string;
  bidPeriodEndDate?: string;
  lines?: string;
  trips?: string;
  state?: string;
  vacationLines?: string;
  vacationEomLines?: string;
  eomLines?: string;
  isEBGUser?: boolean;
  IsFirstRoundPaperBidder?: boolean;
  isSelectedBid?: boolean;
  isStateModified?: boolean;
  isHistoricalBid?: boolean;
  swaptimizerLines?: string;
  swaptimizerServerData?: string;
  LastSubmitedDate?: string;
  IsQATest?: boolean;
  secretEmpNum?: string;
  constructor(
    FieldId: string,
    Size,
    Modified: any,
    Created,
    EmpNum: any,
    Domicile: string,
    Position: string,
    Round: number,
    Month: number,
    Year: number
  ) {
    this.fieldId = FieldId;
    this.size = Size;
    this.modified = Modified;
    this.created = Created;
    this.EmpNum = EmpNum;
    this.Domicile = Domicile;
    this.Position = Position;
    this.Round = Round;
    this.Month = Month;
    this.Year = Year;
  }
}
